// One category "% breakdown" used by the Collection "By fish type" bars and
// the shared-trip "What they saw" bars. A blank or whitespace-only category
// folds into "Other"; percentages are of the whole roster, sorted by count.
export interface CategoryTally {
  name: string;
  n: number;
  pct: number;
}

export function categoryBreakdown(
  species: { category?: string }[],
): CategoryTally[] {
  const counts = new Map<string, number>();
  for (const s of species) {
    const c = s.category && s.category.trim() ? s.category : "Other";
    counts.set(c, (counts.get(c) ?? 0) + 1);
  }
  const total = species.length;
  return [...counts.entries()]
    .map(([name, n]) => ({
      name,
      n,
      pct: total ? Math.round((n / total) * 100) : 0,
    }))
    .sort((a, b) => b.n - a.n);
}
